import { useQuery } from '@tanstack/react-query';
import useAuthContext from 'src/context/AuthProvider/useAuthContext';
import GetAvailableCreditsUseCase from 'src/features/pariWallet/domain/useCases/GetAvailableCreditsUseCase';
import { diContainer } from 'src/inversify.config';
import { useGrowthbookSubdomainFlags } from 'src/common/hooks/useGrowthbookSubdomainFlags';

interface UseAvailableCreditsParams {
  totalOrder: number;
}

const getAvailableCreditsUseCase = diContainer.get<GetAvailableCreditsUseCase>(
  GetAvailableCreditsUseCase
);

export default function useAvailableCredits({
  totalOrder,
}: UseAvailableCreditsParams) {
  const isPariWalletEnabled = useGrowthbookSubdomainFlags(
    'ENABLE_PARI_WALLET',
    false
  );
  const { session } = useAuthContext();

  const query = useQuery({
    queryKey: [
      'availableCredits',
      { user_pk: session?.user.pk, user_uuid: session?.user.uuid },
      totalOrder,
    ],
    queryFn: async () => {
      return getAvailableCreditsUseCase.execute({
        userUuid: session!.user.uuid,
        totalOrder,
      });
    },
    enabled:
      !!session?.user.pk &&
      !!session.user.uuid &&
      isPariWalletEnabled &&
      typeof totalOrder === 'number',
  });

  return {
    ...query,
    totalCredits: query.data?.total_credits || 0,
    availableCredits: query.data?.available_credits || 0,
  };
}
